/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import StringEntry from "../datatypeComponents/StringEntry";
import ReferenceEntry from "../datatypeComponents/ReferenceEntry";
import CodeableConceptEntry from "../datatypeComponents/CodeableConceptEntry";
import { useDispatch, useSelector } from "react-redux";
import { selectAllResourceChanges } from "../slices/resourceChangeReport/resourceChangeReportSlice";
import { resourceUpdated, selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import updateChangeReport from "../slices/resourceChangeReport/updateChangeReport";
import MarkdownEntry from "../datatypeComponents/MarkdownEntry";
import ArrayEntry from "../datatypeComponents/ArrayEntry";
import CodeEntry from "../datatypeComponents/CodeEntry";

const documentReferenceTypeValueSet = [
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "statistical-analysis-plan",
            "display": "Statistical analysis plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "data-management-plan",
            "display": "Data management plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "interim-analysis-plan",
            "display": "Interim analysis plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "adverse-event-monitoring-plan",
            "display": "Adverse event monitoring plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "auditing-plan",
            "display": "Auditing plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "irb-approval",
            "display": "IRB approval"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "dissemination-plan",
            "display": "Dissemination plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "consent-form",
            "display": "Consent form"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "consent-plan",
            "display": "Consent plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "confidential-personal-data-management-plan",
            "display": "Confidential personal data management plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "declaration-of-interests",
            "display": "Declaration of interests"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "data-access-plan",
            "display": "Data access plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "ancillary-care-plan",
            "display": "Ancillary care plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "dataset",
            "display": "Dataset"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "dataset-access",
            "display": "Dataset access"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "software",
            "display": "Software"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "software-access",
            "display": "Software access"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "education",
            "display": "Education"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "specimen-plan",
            "display": "Specimen plan"
        }
        ]
    }
];

const DocumentReferenceResourceEdit = ({ foi }) => {

    const dispatch = useDispatch();
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let initialResourceJson = newResourceDetail.resourceJson;
    let resourceJson = newResourceDetail.revisedResourceJson;

    const [editResourceState, setEditResourceState] = useState({});
    const [resourceLoaded, setResourceLoaded] = useState(false);
    const [extensionState, setExtensionState] = useState({ "otherExtensions": [], "title": "" });
    const [startingExtensionState, setStartingExtensionState] = useState({ "otherExtensions": [], "title": "" });

    useEffect(() => {
        if (resourceJson && !resourceLoaded) {
            let startingExtension = resourceJson.extension || [];
            let startingExtensionStateValue = { "otherExtensions": [], "title": resourceJson.title || "" };
            if (Array.isArray(startingExtension) && startingExtension.length > 0) {
                for (const extension of startingExtension) {
                    switch (extension.url) {
                        case 'http://hl7.org/fhir/StructureDefinition/artifact-title':
                            startingExtensionStateValue.title = extension.valueString;
                            break;
                        default:
                            startingExtensionStateValue.otherExtensions.push(extension)
                    }
                }
            }
            setExtensionState(JSON.parse(JSON.stringify(startingExtensionStateValue)));
            setStartingExtensionState(JSON.parse(JSON.stringify(startingExtensionStateValue)));
            if (!resourceJson.content || !Array.isArray(resourceJson.content) || resourceJson.content.length === 0) {
                resourceJson.content = [
                    {
                        "attachment": ""
                    }
                ]
            }
            setEditResourceState({
                extension: resourceJson.extension,
                identifier: resourceJson.identifier,
                version: resourceJson.version,
                status: resourceJson.status,
                docStatus: resourceJson.docStatus,
                type: resourceJson.type,
                category: resourceJson.category,
                subject: resourceJson.subject,
                related: resourceJson.related,
                author: resourceJson.author,
                custodian: resourceJson.custodian,
                description: resourceJson.description,
                content: resourceJson.content
            });
            setResourceLoaded(true);
        }
    }, [resourceLoaded]);

    useEffect(() => {
        if (extensionState && JSON.stringify(extensionState) !== JSON.stringify(startingExtensionState)) {
            let newExtension = [];
            if (extensionState.otherExtensions) {
                newExtension = JSON.parse(JSON.stringify(extensionState.otherExtensions));
            }
            if (extensionState.title) {
                newExtension.push({
                    "url": "http://hl7.org/fhir/StructureDefinition/artifact-title",
                    "valueString": extensionState.title
                });
            }
            if (!(newExtension.length > 0)) {
                newExtension = null;
            }
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            if (JSON.stringify(newResourceDetail.revisedResourceJson.extension) !== JSON.stringify(newExtension)) {
                newResourceDetail.revisedResourceJson.extension = newExtension;
                newResourceDetail.displayTitle = extensionState.title;
                dispatch(resourceUpdated(newResourceDetail));
                console.log("resourceUpdate for DocumentReference.extension");
                updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
                    "ArrayOfExtension",
                    "extension",
                    startingExtensionState,
                    extensionState);
            }
        }
    }, [extensionState.title]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.identifier;
            previousFinalValue = newResourceDetail.revisedResourceJson.identifier || [];
            newResourceDetail.revisedResourceJson.identifier = editResourceState.identifier;
            if (editResourceState.identifier !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.identifier)) {
                console.log("resourceUpdate for DocumentReference.identifier");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "ArrayOfIdentifier",
                    "identifier",
                    previousInitialValue,
                    editResourceState.identifier);
            }
        }
    }, [editResourceState.identifier]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.version;
            previousFinalValue = newResourceDetail.revisedResourceJson.version;
            newResourceDetail.revisedResourceJson.version = editResourceState.version;
            if (editResourceState.version !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.version) &&
                !(!previousFinalValue && !editResourceState.version)) {
                console.log("resourceUpdate for DocumentReference.version");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "string",
                    "version",
                    previousInitialValue,
                    editResourceState.version);
            }
        }
    }, [editResourceState.version]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.status;
            previousFinalValue = newResourceDetail.revisedResourceJson.status;
            newResourceDetail.revisedResourceJson.status = editResourceState.status;
            if (editResourceState.status !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.status) &&
                !(!previousFinalValue && !editResourceState.status)) {
                console.log("resourceUpdate for DocumentReference.status");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "code",
                    "status",
                    previousInitialValue,
                    editResourceState.status);
            }
        }
    }, [editResourceState.status]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.docStatus;
            previousFinalValue = newResourceDetail.revisedResourceJson.docStatus;
            newResourceDetail.revisedResourceJson.docStatus = editResourceState.docStatus;
            if (editResourceState.docStatus !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.docStatus) &&
                !(!previousFinalValue && !editResourceState.docStatus)) {
                console.log("resourceUpdate for DocumentReference.docStatus");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "code",
                    "docStatus",
                    previousInitialValue,
                    editResourceState.docStatus);
            }
        }
    }, [editResourceState.docStatus]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.type;
            previousFinalValue = newResourceDetail.revisedResourceJson.type;
            newResourceDetail.revisedResourceJson.type = editResourceState.type;
            if (editResourceState.type !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.type) &&
                !(!previousFinalValue && !editResourceState.type)) {
                console.log("resourceUpdate for DocumentReference.type");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "CodeableConcept",
                    "type",
                    previousInitialValue,
                    editResourceState.type);
            }
        }
    }, [editResourceState.type]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.category;
            previousFinalValue = newResourceDetail.revisedResourceJson.category;
            newResourceDetail.revisedResourceJson.category = editResourceState.category;
            if (editResourceState.category !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.category) &&
                !(!previousFinalValue && !editResourceState.category)) {
                console.log("resourceUpdate for DocumentReference.category");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "ArrayOfCodeableConcept",
                    "category",
                    previousInitialValue,
                    editResourceState.category);
            }
        }
    }, [editResourceState.category]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.subject;
            previousFinalValue = newResourceDetail.revisedResourceJson.subject;
            newResourceDetail.revisedResourceJson.subject = editResourceState.subject;
            if (editResourceState.subject !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.subject) &&
                !(!previousFinalValue && !editResourceState.subject)) {
                console.log("resourceUpdate for DocumentReference.subject");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "Reference",
                    "subject",
                    previousInitialValue,
                    editResourceState.subject);
            }
        }
    }, [editResourceState.subject]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.related;
            previousFinalValue = newResourceDetail.revisedResourceJson.related;
            newResourceDetail.revisedResourceJson.related = editResourceState.related;
            if (editResourceState.related !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.related) &&
                !(!previousFinalValue && !editResourceState.related)) {
                console.log("resourceUpdate for DocumentReference.related");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "ArrayOfReference",
                    "related",
                    previousInitialValue,
                    editResourceState.related);
            }
        }
    }, [editResourceState.related]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.author;
            previousFinalValue = newResourceDetail.revisedResourceJson.author;
            newResourceDetail.revisedResourceJson.author = editResourceState.author;
            if (editResourceState.author !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.author) &&
                !(!previousFinalValue && !editResourceState.author)) {
                console.log("resourceUpdate for DocumentReference.author");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "ArrayOfReference",
                    "author",
                    previousInitialValue,
                    editResourceState.author);
            }
        }
    }, [editResourceState.author]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.custodian;
            previousFinalValue = newResourceDetail.revisedResourceJson.custodian;
            newResourceDetail.revisedResourceJson.custodian = editResourceState.custodian;
            if (editResourceState.custodian !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.custodian) &&
                !(!previousFinalValue && !editResourceState.custodian)) {
                console.log("resourceUpdate for DocumentReference.custodian");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "Reference",
                    "custodian",
                    previousInitialValue,
                    editResourceState.custodian);
            }
        }
    }, [editResourceState.custodian]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.description;
            previousFinalValue = newResourceDetail.revisedResourceJson.description;
            newResourceDetail.revisedResourceJson.description = editResourceState.description;
            if (editResourceState.description !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.description) &&
                !(!previousFinalValue && !editResourceState.description)) {
                console.log("resourceUpdate for DocumentReference.description");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "markdown",
                    "description",
                    previousInitialValue,
                    editResourceState.description);
            }
        }
    }, [editResourceState.description]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.content;
            previousFinalValue = newResourceDetail.revisedResourceJson.content;
            newResourceDetail.revisedResourceJson.content = editResourceState.content;
            if (editResourceState.content !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.content) &&
                !(!previousFinalValue && !editResourceState.content)) {
                console.log("resourceUpdate for DocumentReference.content");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "ArrayOfDocumentReferenceContent",
                    "content",
                    previousInitialValue,
                    editResourceState.content);
            }
        }
    }, [editResourceState.content]);

    return <div style={{ marginTop: "12px" }}>
        <div style={{ marginLeft: "24px" }}>
            <StringEntry elementName='title' fieldLabel='Title'
                startingValue={extensionState.title}
                setResourceState={setExtensionState} />
            <CodeableConceptEntry elementName='type' fieldLabel='Type'
                startingValue={editResourceState.type}
                codeableConceptLevelValueSet={documentReferenceTypeValueSet}
                setResourceState={setEditResourceState} />
            <ArrayEntry datatype="DocumentReferenceContent" elementName='content'
                fieldLabel='Content (as Attachment)'
                startingValue={editResourceState.content || []}
                setResourceState={setEditResourceState} />
            <CodeEntry elementName='status' fieldLabel='Resource status'
                startingValue={editResourceState.status || 'current'}
                allowedValues={['current', 'superseded', 'entered-in-error']}
                setResourceState={setEditResourceState} />
            <CodeEntry elementName='docStatus' fieldLabel='Document status'
                startingValue={editResourceState.docStatus}
                allowedValues={['registered', 'partial', 'preliminary', 'final', 'amended', 'corrected', 'appended', 'cancelled', 'entered-in-error', 'deprecated', 'unknown']}
                setResourceState={setEditResourceState} />
            <MarkdownEntry elementName='description' fieldLabel='Description'
                startingValue={editResourceState.description}
                setResourceState={setEditResourceState} />
            <ArrayEntry datatype="CodeableConcept" elementName='category'
                fieldLabel='Category'
                startingValue={editResourceState.category || []}
                setResourceState={setEditResourceState} />
            <ArrayEntry datatype="Identifier" elementName='identifier'
                fieldLabel='Identifier'
                startingValue={editResourceState.identifier || []}
                setResourceState={setEditResourceState} />
            <StringEntry elementName='version' fieldLabel='Version'
                startingValue={editResourceState.version}
                setResourceState={setEditResourceState} />
            <ReferenceEntry elementName='subject'
                fieldLabel='Subject'
                startingValue={editResourceState.subject || null}
                setResourceState={setEditResourceState} />
            <ArrayEntry datatype="Reference" elementName='related'
                fieldLabel='Related Item'
                startingValue={editResourceState.related || []}
                setResourceState={setEditResourceState} />
            <ArrayEntry datatype="Reference" elementName='author'
                fieldLabel='Author'
                referencedResourceTypes={["Practitioner", "PractitionerRole", "Organization", "Device", "Patient", "RelatedPerson", "CareTeam", "Group"]}
                startingValue={editResourceState.author || []}
                setResourceState={setEditResourceState} />
            <ReferenceEntry elementName='custodian'
                fieldLabel='Custodian' startingResourceType="Organization"
                startingValue={editResourceState.custodian || null}
                setResourceState={setEditResourceState} />
        </div>
    </div>
};

export default DocumentReferenceResourceEdit;